
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metal-resources/metal-market-intelligence",
      function () {
        return require("private-next-pages/metal-resources/metal-market-intelligence/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metal-resources/metal-market-intelligence"])
      });
    }
  